import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsShow", true);
        Vue.set(state, "formIsShow", false);
    },
    showTable(state) {
        state.gridIsShow = true;
        state.formIsShow = false;
    },
    showForm(state) {
        state.gridIsShow = false;
        state.formIsShow = true;
    },
    modifyAmbulansEllatasTipus(state, visible) {
        let tempArray = state.eKatalogusOutpatientTableHeaderFields;

        tempArray.map(item => {
            if (item.name === 'ambulansEllatasTipusa') {
                item.formVisible = visible
            }
            return item;
        });
    },
    modifyEllatasVegeVisible(state, visible) {
        let tempArray = state.eKatalogusOutpatientTableHeaderFields;

        tempArray.map(item => {
            if (item.name === 'ellatasVege') {
                item.formVisible = visible
            }
            return item;
        });

        let tempArray2 = state.eKatalogusFeuTableHeaderFields;

        tempArray2.map(item => {
            if (item.name === 'ellatasVege') {
                item.formVisible = visible
            }
            return item;
        });

        let tempArray3 = state.eKatalogusEgynaposSebeszetFields;

        tempArray3.map(item => {
            if (item.name === 'ellatasVege') {
                item.formVisible = visible
            }
            return item;
        });
    }
}
